import { html, nothing } from 'lit';
import service from '../../../service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '../../../service/tracker';
import store from '../../../store';
import { save, cancelPage } from '../../../store/consents';
import { ConsentGroup } from '../../../types/common';
import type Tefcoms from '../../tef-coms';

export const cancelButton = html`
<one-button
  variant="plain"
  @click=${
  /* eslint-disable indent */
  () => {
    store.dispatch(cancelPage());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {},
    );
  }
}
> Abbrechen
</one-button>`;

export const saveButton = (changesMadePage: boolean) => html`
<one-button
    .disabled=${!changesMadePage}
    @click=${
  () => {
    store.dispatch(save());
  }
  /* eslint-enable indent */
}
> Speichern
</one-button>`;

export const consentGroupTemplate = (consentGroup: ConsentGroup, idx: number, tefComs: Tefcoms) => html`
        
          <tef-coms-consent-group
              .consentGroup=${consentGroup}
              .groupIndex=${idx}
              .mode=${tefComs.mode}
          >
          </tef-coms-consent-group>
        `;

export const buttonModeTemplate = (buttonModeButton: string, changesMadePage: boolean) => html`
        <one-section size="xxs">
          <one-button-group>
            ${!buttonModeButton || buttonModeButton === 'save'
    ? saveButton(changesMadePage)
    : nothing}
            <one-spacer size="fill"></one-spacer>
            ${!buttonModeButton ? cancelButton : nothing}
          </one-button-group>
        </one-section>
      `;
